import { render, staticRenderFns } from "./topShareControl.vue?vue&type=template&id=54603c94&scoped=true"
import script from "./topShareControl.vue?vue&type=script&lang=js"
export * from "./topShareControl.vue?vue&type=script&lang=js"
import style0 from "./topShareControl.vue?vue&type=style&index=0&id=54603c94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54603c94",
  null
  
)

export default component.exports